<template>
  <div
    id="done-empty"
    class="greedy flex column flex-align-center justify-center">
    <p class="chat-bubble">💬</p>
  </div>
</template>

<script>
export default {
  name: 'DoneEmpty',
};
</script>

<style lang="scss" scoped>
#done-empty {
  overflow: hidden;
  margin: 0px;

  p {
    font-size: 15px;
    font-weight: 400;
    color: $blackUltralight;
    margin-bottom: 35px;
  }

  .chat-bubble {
    font-size: 40px;
    opacity: 0.5;
    margin-bottom: 10px;
  }
}
</style>
